import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'

import usePaymentVerificator from '@features/payment/hooks/usePaymentVerificator'

import './payment-verification.scss'
import VerificationFailure from './VerificationFailure'
import VerificationSuccess from './VerificationSuccess'

export default function PaymentVerification () {
  const { t } = useTranslation('payment')
  const { operationId } = useParams<{ operationId: string }>()

  const { verified, rejected, metadata, isLoading } = usePaymentVerificator({
    operationId: operationId || null,
  })

  useEffect(() => {
    const onUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault()
      event.returnValue = t('verification.unload_warning')
    }

    window.addEventListener('beforeunload', onUnload)

    return () => {
      window.removeEventListener('beforeunload', onUnload)
    }
  }, [ t ])

  if (verified) {
    return <VerificationSuccess metadata={metadata} />
  }

  if (rejected) {
    return <VerificationFailure metadata={metadata} />
  }

  if (isLoading) {
    return (
      <div className="verification-loading">
        <div className="verification-loading__spinner" />
        <p className="verification-loading__message">
          {t('verification.loading')}
        </p>
      </div>
    )
  }

  return null
}
